import { Vector3 } from "three";
import { EvaluationResult } from "../../../evaluators/EvaluationResult";
import { ParameterDataType } from "../../../evaluators/ParameterDataType";
import { DataTypes } from "./DataTypes";
import { LomaFunction } from "../LomaFunction";
import { LomaVariable } from "../LomaVariable";

export class Types
{
  static functions:LomaFunction[] =
  [
    LomaFunction.create( 
      "Vector3",
       ( e, fe, values )=>
       { 
        let x = values[ 0 ].data;
        let y = values[ 1 ].data;
        let z = values[ 2 ].data;

        let vector3 = new Vector3( x, y, z );

        return EvaluationResult.withValue( vector3, DataTypes.Vector3 );
       }, 
       [ 
        ParameterDataType.from( "x", DataTypes.Number ), 
        ParameterDataType.from( "y", DataTypes.Number ), 
        ParameterDataType.from( "z", DataTypes.Number )
       ],  
       DataTypes.Vector3 
    ),
  ]   
  
}